import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgStripe = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    {...props}
    width={32}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 6.88c0-2.276-1.102-4.071-3.209-4.071-2.116 0-3.396 1.795-3.396 4.053 0 2.675 1.512 4.027 3.68 4.027 1.058 0 1.858-.24 2.463-.578V8.533c-.605.302-1.298.489-2.178.489-.862 0-1.627-.302-1.724-1.351h4.346c0-.116.018-.578.018-.791Zm-4.391-.845c0-1.004.613-1.422 1.173-1.422.542 0 1.12.418 1.12 1.422H27.61ZM21.965 2.809c-.872 0-1.432.408-1.743.693l-.115-.551H18.15v10.364l2.222-.47.01-2.516c.32.23.79.56 1.573.56 1.59 0 3.04-1.28 3.04-4.098-.01-2.578-1.476-3.982-3.031-3.982Zm-.534 6.124c-.524 0-.835-.187-1.049-.418l-.009-3.298c.232-.257.551-.435 1.058-.435.809 0 1.369.907 1.369 2.071 0 1.191-.551 2.08-1.369 2.08ZM15.093 2.284l2.231-.48V0l-2.23.471v1.813Z"
      fill="#635BFF"
    />
    <path d="M17.324 2.96h-2.23v7.779h2.23V2.96Z" fill="#635BFF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m12.702 3.619-.142-.658h-1.92v7.778h2.222V5.468c.525-.685 1.414-.56 1.69-.463V2.961c-.285-.107-1.325-.302-1.85.658ZM8.258 1.031l-2.17.462-.008 7.12c0 1.316.986 2.285 2.302 2.285.729 0 1.262-.133 1.556-.293V8.8c-.285.116-1.69.525-1.69-.791V4.853h1.69V2.96h-1.69l.01-1.929ZM2.249 5.217c0-.346.284-.48.755-.48.676 0 1.53.205 2.205.57v-2.09a5.862 5.862 0 0 0-2.205-.408C1.2 2.809 0 3.75 0 5.324c0 2.453 3.378 2.062 3.378 3.12 0 .409-.356.542-.854.542-.737 0-1.68-.302-2.426-.71v2.115a6.161 6.161 0 0 0 2.426.507c1.85 0 3.12-.916 3.12-2.507C5.636 5.74 2.25 6.213 2.25 5.217Z"
      fill="#635BFF"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStripe);
export default ForwardRef;
